import RegisterCompanyForm from "./RegisterCompanyForm";

export default RegisterCompanyForm;
